<template >
  <input
    class="dpr-inline-edit-input"
    v-if="visible"
    type="text"
    v-model="value"
    @keypress="onKeypress"
  />
  <span
    v-else
    v-on:click="visible = true"
    style="cursor: text"
    class="dpr-e-label"
  >
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'editable-input',
  props: {
    initialValue: [String, Number],
    itemId: String
  },
  model: {
    prop: 'initialValue'
  },
  data() {
    return {
      value: this.initialValue,
      visible: false
    }
  },
  watch: {
    initialValue() {}
  },
  methods: {
    onDocumentClick(e) {
      if (e.target.className.indexOf('dpr-e-label') == -1) {
        this.visible = false
      }
    },
    onInput() {
      this.$log.debug('save input back', this.value)
      this.$emit('input', this.value)
    },
    onKeypress(e) {
      e = e || window.event
      const keyCode = e.keyCode || e.which
      let isEnter = e.key == 'Enter' && keyCode == 13
      let isEscape = e.key == 'Escape' && keyCode == 27

      if (isEnter || isEscape) {
        this.visible = false
      }

      if (isEnter) {
         this.$emit('einput-changed', { id: this.itemId, value : this.value });
      }
    }
  },
  mounted: function () {
    let self = this

    window.addEventListener('keyup', function (e) {
      e = e || window.event
      const keyCode = e.keyCode || e.which;

      let isEscape = e.key == 'Escape' && keyCode == 27
      if (isEscape) {
        self.visible = false;
      }
    })
  }
}
</script>
<style scoped>
.dpr-inline-edit-input {
  border-bottom: 1px solid;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 4px 0 4px;
  max-width: 100%;
  min-width: 0px;
  width: 100%;
}

.dpr-inline-edit-input:focus {
  outline-width: 0;
}
</style>